import { ACTION } from '@approot/global-websocket';

export enum RunningState {
  Running = 'RUNNING',
  Idle = 'IDLE'
}

type Payload = {
  item: any;
  nItems: number;
  error: boolean;
  warning: boolean;
  message: string;
};

export type Row = Payload & { uuid: string; info: string };

export type WSRow = {
  action: ACTION;
  uuid: string;
  payload: Payload;
};

export type LifecycleBlotterPayload = {
  entity: string;
  timezone: string;
  date: string;
  time: string;
};

export type LifecycleBlotterState = Partial<{
  uuid: string;
  headers: any[];
  rows: any[];
  entities: string[];
  selectedEntry: LifecycleBlotterPayload;
  nItems: number;
  runningState: RunningState;
  info: string;
}>;
